import { useEffect } from "react";
import customer01 from "./../assets/img/customer01.png";
import customer02 from "./../assets/img/customer02.png";
import customer03 from "./../assets/img/customer03.png";
import customer04 from "./../assets/img/customer04.png";
import customer05 from "./../assets/img/customer05.png";
import customer06 from "./../assets/img/customer06.png";
import customer07 from "./../assets/img/customer07.png";
import customer08 from "./../assets/img/customer08.png";
import customer09 from "./../assets/img/customer09.png";
import customer10 from "./../assets/img/customer10.png";
import customer11 from "./../assets/img/customer11.png";
import customer12 from "./../assets/img/customer12.png";
import customer13 from "./../assets/img/customer13.png";
import customer14 from "./../assets/img/customer14.png";
import customer15 from "./../assets/img/customer15.png";
import customer16 from "./../assets/img/customer16.png";
import customer17 from "./../assets/img/customer17.png";
import customer18 from "./../assets/img/customer18.png";
import customer19 from "./../assets/img/customer19.png";
import customer20 from "./../assets/img/customer20.png";
import customer21 from "./../assets/img/customer21.png";
import customer22 from "./../assets/img/customer22.png";
import customer23 from "./../assets/img/customer23.png";
import customer24 from "./../assets/img/customer24.png";
import customer25 from "./../assets/img/customer25.png";
import cowork1 from "./../assets/img/cowork1.png";
import cowork2 from "./../assets/img/cowork2.png";
import cowork3 from "./../assets/img/cowork3.png";
import cowork4 from "./../assets/img/cowork4.png";
import cowork5 from "./../assets/img/cowork5.png";
import cowork6 from "./../assets/img/cowork6.png";
import cowork7 from "./../assets/img/cowork7.png";
import cowork8 from "./../assets/img/cowork8.png";
import cowork9 from "./../assets/img/cowork9.png";
import cowork10 from "./../assets/img/cowork10.png";
import cowork11 from "./../assets/img/cowork11.png";
import cowork12 from "./../assets/img/cowork12.png";
import cowork13 from "./../assets/img/cowork13.png";
import cowork14 from "./../assets/img/cowork14.png";
import cowork15 from "./../assets/img/cowork15.png";
import cowork16 from "./../assets/img/cowork16.png";
import cowork17 from "./../assets/img/cowork17.png";
import cowork18 from "./../assets/img/cowork18.png";
import cowork19 from "./../assets/img/cowork19.png";
import cowork20 from "./../assets/img/cowork20.png";
import cowork21 from "./../assets/img/cowork21.png";
import cowork22 from "./../assets/img/cowork22.png";
import cowork23 from "./../assets/img/cowork23.png";
// import customer2 from "./../assets/img/Customer2.png";
import customer3 from "./../assets/img/Customer3.png";
// import mcustomer2 from "./../assets/img/MCustomer2.png";
import mcustomer3 from "./../assets/img/MCustomer3.png";
import { useMediaQuery } from "react-responsive";

function AboutCustomer({ getLink, getData }) {
  useEffect(() => {
    getLink(window.location.href);
    getData(
      "고객사",
      "다양한 공공기관 및 협력사, 협력 대학과 함께",
      "협업을 진행하며 프로젝트를 진행했습니다."
    );
  }, [getLink, getData]);

  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  return (
    <div className="inner main-customer">
      <div>
        <h2 className="basic-title">공공행정기관</h2>
        <div className="basic-subtitle">다양한 공공기관과 함께 했습니다.</div>
        <div className="customer-item">
          <div className="customer-item-inner">
            <img className="customer-img" src={customer01} alt="MOI" />
            <img className="customer-img" src={customer02} alt="MOI" />
            <img className="customer-img" src={customer03} alt="MOI" />
            <img className="customer-img" src={customer05} alt="MOI" />
            <img className="customer-img" src={customer15} alt="MOI" />
            <img className="customer-img" src={customer16} alt="MOI" />
            <img className="customer-img" src={customer04} alt="MOI" />
          </div>
          <div className="customer-item-inner">
            <img className="customer-img" src={customer11} alt="MOI" />
            <img className="customer-img" src={customer17} alt="MOI" />
            <img className="customer-img" src={customer12} alt="MOI" />
            <img className="customer-img" src={customer13} alt="MOI" />
          </div>
          <div className="customer-item-inner">
            <img className="customer-img" src={customer07} alt="MOI" />
            <img className="customer-img" src={customer08} alt="MOI" />
            <img className="customer-img" src={customer06} alt="MOI" />
            <img className="customer-img" src={customer24} alt="MOI" />
            <img className="customer-img" src={customer25} alt="MOI" />
          </div>
          <div className="customer-item-inner">
            <img className="customer-img" src={customer14} alt="MOI" />
            <img className="customer-img" src={customer09} alt="MOI" />
            <img className="customer-img" src={customer10} alt="MOI" />
          </div>
          <div className="customer-item-inner">
            <img className="customer-img" src={customer18} alt="MOI" />
            <img className="customer-img" src={customer19} alt="MOI" />
            <img className="customer-img" src={customer20} alt="MOI" />
            <img className="customer-img" src={customer21} alt="MOI" />
            <img className="customer-img" src={customer22} alt="MOI" />
            <img className="customer-img" src={customer23} alt="MOI" />
          </div>
        </div>
      </div>
      <div className="section-customer">
        <h2 className="basic-title">협력사</h2>

        <div className="basic-subtitle">
          많은 전문기업과 협업을 통해 프로젝트를 진행합니다
        </div>
        <div className="customer-item">
          <div className="customer-item-inner">
            <img className="customer-img" src={cowork1} alt="MOI" />
            <img className="customer-img" src={cowork2} alt="MOI" />
            <img className="customer-img" src={cowork3} alt="MOI" />
            <img className="customer-img" src={cowork4} alt="MOI" />
            <img className="customer-img" src={cowork5} alt="MOI" />
            <img className="customer-img" src={cowork6} alt="MOI" />
            <img className="customer-img" src={cowork7} alt="MOI" />
            <img className="customer-img" src={cowork8} alt="MOI" />
            <img className="customer-img" src={cowork9} alt="MOI" />
            <img className="customer-img" src={cowork10} alt="MOI" />
            <img className="customer-img" src={cowork11} alt="MOI" />
            <img className="customer-img" src={cowork12} alt="MOI" />
            <img className="customer-img" src={cowork13} alt="MOI" />
            <img className="customer-img" src={cowork14} alt="MOI" />
            <img className="customer-img" src={cowork15} alt="MOI" />
            <img className="customer-img" src={cowork16} alt="MOI" />
            <img className="customer-img" src={cowork17} alt="MOI" />
            <img className="customer-img" src={cowork18} alt="MOI" />
            <img className="customer-img" src={cowork19} alt="MOI" />
            <img className="customer-img" src={cowork20} alt="MOI" />
            <img className="customer-img" src={cowork21} alt="MOI" />
            <img className="customer-img" src={cowork22} alt="MOI" />
            <img className="customer-img" src={cowork23} alt="MOI" />
          </div>
        </div>
      </div>
      <div>
        <h2 className="basic-title">협력 대학</h2>
        {pc ? (
          <>
            <div className="basic-subtitle">
              많은 대학교과 협업을 통해 프로젝트를 진행합니다
            </div>
            <div className="customer-item-base">
              <p>
                <img className="customer-img-base" src={customer3} alt="MOI" />
              </p>
            </div>
          </>
        ) : (
          <>
            <div className="basic-subtitle">
              <p>많은 대학교과 협업을 통해 프로젝트를</p>
              <p>진행합니다</p>
            </div>
            <div className="customer-item-base">
              <p>
                <img className="customer-img-base" src={mcustomer3} alt="MOI" />
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default AboutCustomer;
